// extracted by mini-css-extract-plugin
export default {"root":"PatientHistory_root__SxTAn","tooltip":"PatientHistory_tooltip__KpIEV","form":"PatientHistory_form__oFbT3"};